// src/app/modules/AccessControl/pages/components/CheckoutConfirmModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import Moment from 'moment';
import { X, LogOut, User, Phone, Clock, Calendar, RefreshCw } from 'lucide-react';
import './CheckoutConfirmModal.scss';

export function CheckoutConfirmModal({ show, onHide, accessLog, onConfirm, loading }) {
  if (!accessLog) return null;

  const calculateDuration = () => {
    if (!accessLog.entry_time) return null;
    const mins = Math.round((new Date() - new Date(accessLog.entry_time)) / 60000);
    if (mins < 60) return `${mins}m`;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  };

  const duration = calculateDuration();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      className="checkout-confirm-modal"
    >
      <div className="checkout-modal-content">

        {/* ── Header ─────────────────────────────────────────────────────── */}
        <div className="modal-header-custom">
          <div className="ccm-header-left">
            <div className="ccm-header-icon">
              <LogOut size={15} />
            </div>
            <div className="ccm-header-text">
              <h3>Check Out Visitor</h3>
              <p>Confirm and record exit time</p>
            </div>
          </div>
          <button
            className="btn-close-custom"
            onClick={onHide}
            disabled={loading}
          >
            <X size={15} />
          </button>
        </div>

        {/* ── Body ───────────────────────────────────────────────────────── */}
        <div className="modal-body-custom">

          {/* Duration banner */}
          <div className="ccm-banner">
            <div className="ccm-banner__icon">
              <LogOut size={18} />
            </div>
            <div className="ccm-banner__text">
              <strong>{accessLog.visitor_name || 'Visitor'}</strong>
              <span>Ready to check out</span>
            </div>
            {duration && (
              <span className="ccm-banner__duration">
                <Clock size={12} />
                {duration}
              </span>
            )}
          </div>

          {/* Detail rows */}
          <div className="ccm-rows">
            {accessLog.visitor_name && (
              <div className="ccm-row">
                <span className="ccm-row__label"><User size={13} />Visitor</span>
                <span className="ccm-row__value">{accessLog.visitor_name}</span>
              </div>
            )}
            {accessLog.visitor_phone && (
              <div className="ccm-row">
                <span className="ccm-row__label"><Phone size={13} />Phone</span>
                <span className="ccm-row__value">{accessLog.visitor_phone}</span>
              </div>
            )}
            {accessLog.host_name && (
              <div className="ccm-row">
                <span className="ccm-row__label"><User size={13} />Here to see</span>
                <span className="ccm-row__value">{accessLog.host_name}</span>
              </div>
            )}
            {accessLog.entry_time && (
              <div className="ccm-row">
                <span className="ccm-row__label"><Calendar size={13} />Checked in</span>
                <span className="ccm-row__value">
                  {Moment(accessLog.entry_time).format('MMM DD [at] h:mm A')}
                </span>
              </div>
            )}
          </div>

        </div>

        {/* ── Footer ─────────────────────────────────────────────────────── */}
        <div className="modal-footer-custom">
          <button
            className="sety-btn sety-btn-ghost"
            onClick={onHide}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary btn-sm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading
              ? <><RefreshCw size={13} className="spin mr-1" />Checking out…</>
              : <><LogOut size={13} className="mr-1" />Check Out</>
            }
          </button>
        </div>

      </div>
    </Modal>
  );
}